import './Contract.css'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router-dom";

function Contract() {
  const navigate = useNavigate();

  return(
    <div className="">

    <div>
      <button className="bg-gray-200 rounded-lg p-2 py-3 self-start m-10"
        onClick={(e) => {
          e.preventDefault();
          navigate("/");
        }}><ArrowBackIosIcon sx={{ marginLeft: '8px' }} /></button>
    </div>

    <div className="contract text-black">
        <h1 className="text-[color:--primary-color] text-center pt-10 font-extrabold text-2xl m-auto">Contrato</h1>
      <div className="bg-gray-100 rounded-lg shadow-md max-w-[800px] md:mx-auto mx-10 p-5 my-10">
        <p className="overflow-y-scroll h-[70vh]">CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE COWORKING
IDENTIFICAÇÃO DAS PARTES CONTRATANTES
Contratante: [Nome completo do cliente], inscrito no CPF/CNPJ sob o número [número do CPF/CNPJ], residente/domiciliado em [endereço completo].
Contratada: [Nome do Coworking], inscrita no CNPJ sob o número [número do CNPJ], com sede em [endereço completo], neste ato representada por [nome do representante legal], portador(a) do CPF nº [número do CPF].
As partes acima identificadas têm entre si justo e acordado o presente Contrato de Prestação de Serviços de Coworking, que se regerá pelas cláusulas e condições a seguir estipuladas.
CLÁUSULA 1ª — OBJETO DO CONTRATO
A Contratada se compromete a disponibilizar à Contratante o uso compartilhado de estações de trabalho, salas de reunião e outras áreas comuns descritas neste contrato, conforme as condições estipuladas nas cláusulas seguintes.
CLÁUSULA 2ª — SERVIÇOS OFERECIDOS
A Contratada disponibilizará à Contratante os seguintes serviços e estruturas:
Estações de trabalho compartilhadas;
Salas de reunião mediante agendamento prévio;
Conexão à internet (Wi-Fi) de alta velocidade;
Endereço fiscal e/ou comercial (opcional, conforme pacote contratado);
Acesso às áreas de convivência (cozinha, área de descanso, etc.);
Outros serviços adicionais descritos no anexo [inserir o nome do anexo se aplicável].
CLÁUSULA 3ª — PLANOS, PREÇOS E FORMAS DE PAGAMENTO
O valor mensal referente ao plano contratado é de R$ [valor do plano] (reais), que será pago por meio de [forma de pagamento: cartão de crédito, PIX, boleto, etc.], conforme as condições escolhidas no momento da adesão.
O pagamento deverá ser efetuado até o dia [dia do vencimento] de cada mês, sob pena de incidência de multa de [percentual ou valor] e juros de [percentual] ao mês em caso de atraso.
Caso o contrato seja rescindido antes do término do ciclo mensal, não haverá devolução de valores pagos.
CLÁUSULA 4ª — DURAÇÃO DO CONTRATO
Este contrato tem duração de [prazo do contrato] meses, com início em [data de início] e término em [data de término].
O contrato será renovado automaticamente ao término do período, salvo manifestação contrária de qualquer das partes, com antecedência de [prazo] dias.
CLÁUSULA 5ª — OBRIGAÇÕES DAS PARTES
Obrigações da Contratada:
Disponibilizar à Contratante os serviços e estruturas previstos na Cláusula 2ª deste contrato;
Manter as áreas comuns limpas, organizadas e em pleno funcionamento;
Zelar pela segurança e pelo bem-estar dos usuários.
Obrigações da Contratante:
Respeitar as normas de convivência estabelecidas pela Contratada;
Pagar, pontualmente, os valores acordados na Cláusula 3ª;
Utilizar as áreas e equipamentos de forma responsável e adequada.
CLÁUSULA 6ª — RESCISÃO CONTRATUAL
O contrato pode ser rescindido a qualquer momento, por qualquer das partes, mediante aviso prévio de [prazo] dias.
O não cumprimento de qualquer das cláusulas deste contrato pode ensejar sua rescisão imediata, sem necessidade de aviso prévio, por parte da parte prejudicada.
CLÁUSULA 7ª — USO DO ENDEREÇO FISCAL/COMERCIAL
O endereço disponibilizado pela Contratada pode ser utilizado pela Contratante para fins fiscais ou comerciais, conforme contratado.
O uso do endereço fiscal está condicionado à contratação de um plano específico que inclua este serviço.
Caso a Contratante deseje cancelar o uso do endereço fiscal, deverá solicitar com antecedência mínima de [prazo] dias.
CLÁUSULA 8ª — DISPOSIÇÕES GERAIS
As partes concordam que este contrato não estabelece qualquer tipo de sociedade, associação ou relação empregatícia entre as partes.
Quaisquer alterações neste contrato deverão ser formalizadas por escrito e assinadas por ambas as partes.
CLÁUSULA 9ª — FORO
        As partes elegem o foro da comarca de [cidade/estado] para dirimir quaisquer dúvidas ou litígios oriundos deste contrato.</p>
      </div>

      <div className="bg-[#fafafa] m-auto text-center p-5 w-96 rounded-lg shadow-lg mb-10">
        <p className="font-semibold pb-1">Assinatura digital</p>
        <button className="bg-[#f4f4f4] my-4 text-xs font-semibold py-1 border-2 border-dotted border-[color:--secondary-color] rounded-lg w-80 text-[color:--secondary-color]"
        onClick={(e) => {
          e.preventDefault();
          navigate("/login");
        }}>Assine aqui</button>
      </div>

    </div>
    <div className='footer-bg'></div>
    </div>
  )
}

export default Contract;